<template>
  <div>
    <div id="chart">
      <apexcharts type="area" height="300" :options="barChartOptions" :series="series" v-if="dataLoaded"></apexcharts>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'pickl-purchases',
  components: {
    apexcharts: VueApexCharts
  },
  props: ['brandId', 'successfulpicklData', 'picklPurchasesData'],
  data () {
    return {
      dataLoaded: false,
      barChartOptions: {
        chart: {
          type: 'area',
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          title: {
            text: ''
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + ' pickls'
            }
          }
        }
      },
      series: [{
        name: 'Activities',
        data: []
      }, {
        name: 'Purchases',
        data: []
      }]
    }
  },
  mounted () {
    if (this.successfulpicklData && this.picklPurchasesData) {
      this.updateChartData()
    }
  },
  methods: {
    updateChartData () {
      const categories = this.successfulpicklData.map(item => item.x)
      const createdTasks = this.successfulpicklData.map(item => item.y)
      const failedTasks = this.picklPurchasesData.map(item => item.y)
      this.barChartOptions.xaxis.categories = categories
      this.series[0].data = createdTasks
      this.series[1].data = failedTasks
      this.dataLoaded = true
    }
  },
  watch: {
    successfulpicklData (newVal) {
      if (newVal) {
        this.updateChartData()
      }
    },
    picklPurchasesData (newVal) {
      if (newVal) {
        this.updateChartData()
      }
    }
  }
}
</script>

<style scoped>
.map-container {
  width: 100%;
  height: 438px;
}
</style>
